const projectItems = [
    {
      name: "Juice Center App",
      description:
        "Juice Center App is an advertising page to bring in more influx of customers for the juice center business of my friend.",
      gitLink: "https://github.com/tarunsai217/Juice",
      urlLink: "https://juicecenter.netlify.app/",
      img: "https://i.ibb.co/Scz4x5p/juice.png",
      skills: ["HTML", "CSS", "Bootstrap"],
    },
      {
      name: "Chit-Chat App",
      description:
        "Chit-Chat is a chat application which makes communication seamless and effective.Demo Login- PhoneNumber:9538704512 Password:Tarun@777:",
      gitLink: "https://github.com/pesto-students/chit-chat-frontend-team1-gaurav",
      urlLink: "https://chit-chat-communication.netlify.app/",
      img: "https://i.ibb.co/Gp9qBhT/chit-chat-Img-1.png" ,
      skills: ["React", "Redux", "NodeJs"],
    },
        {
      name: "To-Do List App",
      description:
        "A To Do List App made using React. Has both light and dark mode.",
      gitLink: "https://github.com/tarunsai217/Todos",
      urlLink: "https://todos-flame.vercel.app/",
      img: "https://i.ibb.co/LSrySTS/todo.png",
      skills: ["React", "Sass"],
    },
    {
      name: "React Loading Package",
      description:
        "A react-npm package for developers implementing an overlay loading in their project",
      gitLink: "https://github.com/tarunsai217/react-loading",
      urlLink: "https://www.npmjs.com/package/react-loader-io",
      img:"https://i.ibb.co/2KFWjgJ/react-loading.png",
      skills: ["React", "Webpack", "NPM"],
    },
  ];

  export default projectItems;